import { createContext, useContext } from 'react';
import type { ChartElementContextValue } from '../internalTypes';
export const ChartElementContext = createContext<ChartElementContextValue | null>(null);
export const useChartElementContext = () => {
  const value = useContext(ChartElementContext);
  if (value == null) {
    throw new Error("useChartElementContext must be used within ChartElementContextProvider");
  }
  return value;
};